module.exports = __webpack_public_path__ + "static/media/yandex-device-smart-watch.9601ad5f.png";